import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-837bfcf2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "form"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h5", {
    class: "title"
  }, "选手登录信息", -1);
});
var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 登录 ");
import { computed, reactive, ref } from 'vue';
import { UserService } from '@/services/user.service';
import { DaoService } from '@/services/dao.service';
import { useService } from '@kaokei/use-vue-service';
import { logger, setOtherLoginUrl, setToken } from '@/utils';
import { useRoute, useRouter } from 'vue-router';
import { LoginService } from '@/services/login.service';
export default /*#__PURE__*/_defineComponent({
  props: {
    theme: {
      type: String,
      required: true,
      default: ''
    },
    loginConf: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  setup: function (__props) {
    var _this = this;
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    var userService = useService(UserService);
    var daoService = useService(DaoService);
    var loginService = useService(LoginService);
    var encryptedContestId = computed(function () {
      return route.params.encryptId;
    });
    var loginConf = computed(function () {
      return props.loginConf;
    });
    var formState = reactive({
      account: '',
      password: ''
    });
    var formRules = computed(function () {
      var _a, _b;
      return {
        account: [{
          required: true,
          message: ((_a = loginConf.value) === null || _a === void 0 ? void 0 : _a.accountText) || '请输入账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: ((_b = loginConf.value) === null || _b === void 0 ? void 0 : _b.passwdText) || '请输入密码',
          trigger: 'blur'
        }]
      };
    });
    var formRef = ref();
    var onSubmit = function () {
      formRef.value.validate().then(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var res;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4 /*yield*/, daoService.postUserLoginByConf(encryptedContestId.value, {
                  account: formState.account,
                  password: formState.password
                })];
              case 1:
                res = _a.sent();
                setToken(res.token);
                return [4 /*yield*/, userService.initUserInfo()];
              case 2:
                _a.sent();
                setOtherLoginUrl(location.href);
                loginService.queryGoToEnvCheckDialog();
                router.push({
                  name: 'UserItemList'
                });
                return [2 /*return*/];
            }
          });
        });
      }).catch(function (e) {
        logger.error((e === null || e === void 0 ? void 0 : e.message) || '登录异常');
      });
    };
    return function (_ctx, _cache) {
      var _component_a_input = _resolveComponent("a-input");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_input_password = _resolveComponent("a-input-password");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass("contest-form ".concat(__props.theme && "contest-form-".concat(__props.theme)))
      }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_form, {
        ref: function (_value, _refs) {
          _refs['formRef'] = _value;
          formRef.value = _value;
        },
        rules: _unref(formRules),
        model: _unref(formState),
        "label-col": {
          span: 5
        },
        "wrapper-col": {
          span: 24
        },
        hideRequiredMark: true
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "",
            colns: false,
            name: "account",
            class: "input-item"
          }, {
            default: _withCtx(function () {
              var _a;
              return [_createVNode(_component_a_input, {
                maxlength: 50,
                value: _unref(formState).account,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).account = $event;
                }),
                valueModifiers: {
                  trim: true
                },
                placeholder: ((_a = _unref(loginConf)) === null || _a === void 0 ? void 0 : _a.accountText) || '请输入账号',
                autocomplete: "off",
                class: "input-common"
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "",
            colns: false,
            name: "password",
            class: "input-item"
          }, {
            default: _withCtx(function () {
              var _a;
              return [_createVNode(_component_a_input_password, {
                maxlength: 50,
                value: _unref(formState).password,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(formState).password = $event;
                }),
                valueModifiers: {
                  trim: true
                },
                placeholder: ((_a = _unref(loginConf)) === null || _a === void 0 ? void 0 : _a.passwdText) || '请输入密码',
                autocomplete: "off",
                class: "input-common"
              }, null, 8, ["value", "placeholder"])];
            }),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_button, {
                class: "form-login",
                type: "primary",
                onClick: _withModifiers(onSubmit, ["prevent"])
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["rules", "model"])])], 2);
    };
  }
});